<template>
  <div>
    <title-edit header="Banner" />
    <line-hr />
    <br>
    <div class="row">
      <v-col cols="12" sm="3" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="8" xs="12">
        <v-app class="switch-app">
          <v-switch label="Active" v-model="form.is_active"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Branch * :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option :items="optionBranch" :model="form.branch_id" @update="updateBranch"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Title * :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <input-text-field :model="form.title" @update="updateTitle"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Effect :</label>
      </v-col>
      <v-col cols="12" sm="8"  xs="12">
        <select-option :items="optionEffect" :model="form.effect" @update="updateEffect"/>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="3"  class="label">
        <label>Time effect * :</label>
      </v-col>
      <v-col cols="12" sm="4"  xs="12">
        <input-text-field :model="form.time_effect" @update="updateTimeEffect"/>
      </v-col>
      <v-col cols="12" sm="4"  xs="12">
        <label>Second</label>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="2"></v-col>
      <v-col cols="12" sm="5">
        <div>
          <label>Banner desktop* : </label>
          <div style="color: #2E8037; font-size: 12px">
            *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 700 x 700 px
          </div>
        </div>
        <draggable v-model="form.desktop_images">
          <div v-for="(image,index) in form.desktop_images" :key="index" class="item">
            <a @click="removeDesktopImage(index)">
              <img :src="image.image_url_path" width="450px" height="250px" title="click for remove image">
            </a>
          </div>
        </draggable>
        <div>
          <input-image-upload id="desktop_image" width="450px" height="200px" @update="updateBannerDesktop"/>
        </div>
      </v-col>
      <v-col cols="12" sm="5"  xs="12">
        <div>
          <label>Banner mobile* : </label>
          <div style="color: #2E8037; font-size: 12px">
            *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 700 x 700 px
          </div>
        </div>
        <draggable v-model="form.mobile_images">
          <div v-for="(image,index) in form.mobile_images" :key="index" class="item">
            <a @click="removeMobileImage(index)">
              <img :src="image.image_url_path" width="350px" height="250px" title="click for remove image">
            </a>
          </div>
        </draggable>
        <div>
          <input-image-upload id="mobile_upload" width="350px" height="200px" @update="updateBannerMobile"/>
        </div>
      </v-col>
    </div>
    <br>
    <line-hr />
    <div class="row text-right">
      <v-spacer></v-spacer>
      <delete-button @click.native="deleteBanner"/>
      <preview-button />
      <save-button @click.native="saveBanner"/>
    </div>
<!--    <pre>{{form}}</pre>-->
  </div>
</template>

<script>
  import TitleEdit from "../../components/TitleHeader/TitleEdit";
  import LineHr from "../../components/Icon/line-hr";
  import SelectOption from "../../components/Input/selectOption";
  import InputTextField from "../../components/Input/InputTextField";
  import DeleteButton from "../../components/Button/DeleteButton";
  import PreviewButton from "../../components/Button/PreviewButton";
  import SaveButton from "../../components/Button/SaveButton";
  import draggable from 'vuedraggable'

  import {mapState} from "vuex";
  import InputImageUpload from "../../components/Input/InputImageUpload";
  export default {
    name: "BannerEdit",
    components: {
      InputImageUpload,
      SaveButton,
      draggable,
      PreviewButton, DeleteButton, InputTextField,
      SelectOption, LineHr, TitleEdit},
    data(){
      return{
        optionCategory:[],
        optionBranch : [],
        optionEffect : [
          { value: null, text: "Select" },
          { value: 1, text: "Cube" },
          { value: 2, text: "Fade" },
          { value: 3, text: "Slide" },
        ],
      }
    },
    computed: {
      ...mapState({
        form: state => {
          return state.Banner.form;
        }
      }),
    },
    created() {
      this.getBranchData();
    },
    methods:{
      getBranchData() {
        this.$store.dispatch("Branch/getBranchAll").then(res => {
          this.optionBranch = [
            { text: "Select", value: "" },
            ...res.map(type => ({
              value: type.branch_id,
              text: type.branch_name_th + " (" + type.branch_name_en + ")"
            }))
          ];
        });
      },
      validateData(){
        if(!this.form.branch_id){
          alert('Please Select Branch');
          return false;
        }else if(!this.form.title){
          alert('Please Select Title');
          return false;
        }
        else{
          return true;
        }
      },
      saveBanner(){
        if(this.validateData()){
          this.$store.dispatch("Banner/saveBanner",{
            id : this.form.id,
            data : this.form
          }).then(res=>{
            alert(res.response_msg);
            if(res.response_code == 200){
              this.goToBanner();
            }
          }).catch(()=>{
            alert("cannot save Banner data");
          })
        }
      },
      goToBanner(){
        this.$router.push("/banner");
      },
      deleteBanner(){
        this.$store.dispatch("Banner/deleteBanner",this.form.id).then(res=>{
          alert(res.response_msg);
          if(res.response_code == 200){
            this.goToBanner();
          }
        }).catch(()=>{
          alert("cannot delete Banner data");
        })
      },
      updateBranch(val){
        this.form.branch_id = val;
      },
      updateTitle(val){
        this.form.title = val;
      },
      updateEffect(val){
        this.form.effect = val;
      },
      updateTimeEffect(val){
        this.form.time_effect = val;
      },
      updateBannerDesktop(val){
        this.form.desktop_images.push({
          image_url_path : val.fullImagePath,
          image_url : val.imagePath,
        });
      },
      updateBannerMobile(val){
        this.form.mobile_images.push({
          image_url_path : val.fullImagePath,
          image_url : val.imagePath,
        });
      },
      removeMobileImage(index){
        this.$store.dispatch("Banner/removeMobileImage",index);
      },
      removeDesktopImage(index){
        this.$store.dispatch("Banner/removeDesktopImage",index);
      }
    }
  }
</script>

<style scoped>

</style>
